import * as React from "react";
import type { SVGProps } from "react";
const SvgRetailIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 26"
    {...props}
  >
    <path
      fill="#858585"
      fillRule="evenodd"
      d="M26.303.517A1.1 1.1 0 0 1 27.6 1.599V24h-1.2V1.719L16.107 3.59 5.6 5.5V24H4.4V5.417c0-.531.38-.987.903-1.082l10.59-1.925zM10.6 18.6V24H9.4v-5.5a1.1 1.1 0 0 1 1.1-1.1h11a1.1 1.1 0 0 1 1.1 1.1V24h-1.2v-5.4h-4.8V24h-1.2v-5.4zM0 25h32v1H0zm8-9.5h16v-1H8z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRetailIcon;
